//POPUP
const lockPadding = document.querySelectorAll(".lock-padding");
const body = document.querySelector("body");

function listenersOpenSingIn() {
  document.querySelector("body") &&
    document.querySelector("body").addEventListener("click", function (event) {
      let elEvent = event.target;
      if (elEvent.classList.contains("popup-link") || elEvent.classList.contains("menu_signin_icon")) {
        elEvent = elEvent.closest(".popup-link");
        event.preventDefault();
        const popupName = elEvent.getAttribute("href").replace("#", "");
        const curentPopup = document.getElementById(popupName);
        popupOpen(curentPopup);
      }
    });
}

function listenersCloseSingIn() {
  const popupCloseIcon = document.querySelectorAll(".close-popup");
  if (popupCloseIcon.length > 0) {
    for (let index = 0; index < popupCloseIcon.length; index++) {
      const el = popupCloseIcon[index];
      el.addEventListener("click", function (e) {
        popupClose(el.closest(".popup"));
        e.preventDefault();
      });
    }
  }
}
listenersOpenSingIn();
listenersCloseSingIn();
function popupOpen(curentPopup) {
  if (curentPopup) {
    const popupActive = document.querySelector(".popup.open");
    document.getElementById("signin_email").value = "";
    document.getElementById("signin_password").value = "";
    if (popupActive) {
      popupClose(popupActive);
    } else {
      lockScroll();
    }
    curentPopup.classList.add("open");
    curentPopup.addEventListener("click", (e) => {
      if (!e.target.closest(".popup__content")) {
        popupClose(e.target.closest(".popup"));
      }
    });
  }
}
function popupClose(popupActive) {
  popupActive && popupActive.classList.remove("open");
  unlockScroll();
}

document.addEventListener("keydown", function (e) {
  if (e.which === 27) {
    const popupActive = document.querySelector(".popup.open");
    popupClose(popupActive);
  }
});
//END POPUP

//PASSWORD VISIBLE
let passwordVisible = document.querySelectorAll(".eye-icon");
passwordVisible.forEach((item) =>
  item.addEventListener("click", function () {
    let input = this.closest(".passw-visible").querySelector("input");
    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  })
);
//END PASSWORD VISIBLE

// SIGN IN
function popupRequest(urlRequest, paramsRequest, msgBlockName) {
  const request = new XMLHttpRequest();
  const url = urlRequest;
  console.log(url);
  const params = paramsRequest;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        console.log("request response", request.responseText);
        let response = JSON.parse(request.responseText);
        if (response.status === "ok") {

          // for Google Analytics
          dataLayer.push({'event': 'login_user', 'userId' : response.userID, 'method': 'email'});
          // for Google Analytics END

          document.getElementById("signin_email").value = "";
          document.getElementById("signin_password").value = "";
          window.location.href = response.message;
        }
        if (response.status === "error") {
          let responseErrorsMsg = createErrorsMsg(response.errors);
          showMsg(msgBlockName, responseErrorsMsg);
        }
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}

document.getElementById("btn_log_in") &&
  document.getElementById("btn_log_in").addEventListener("click", function () {
    let inputEmail = document.getElementById("signin_email");
    let inputPass = document.getElementById("signin_password");

    let inputEmailMsg = document.getElementById("signin_email_error");
    let inputPassMsg = document.getElementById("signin_password_error");

    if (!validateEmail(inputEmail)) {
      inputEmailMsg.classList.add("show_msg");
    } else {
      inputEmailMsg.classList.remove("show_msg");
    }
    if (!validateOnEmpty(inputPass)) {
      inputPassMsg.classList.add("show_msg");
      return;
    } else {
      inputPassMsg.classList.remove("show_msg");
    }
    signInRequest(inputEmail.value, inputPass.value);
  });

// for Google Analytics
document.getElementById("signin_google") &&
document.getElementById("signin_google").addEventListener("click", function () {
  dataLayer.push({'event': 'login_user', 'method': 'google'});
});

document.getElementById("signin_facebook") &&
document.getElementById("signin_facebook").addEventListener("click", function () {
  dataLayer.push({'event': 'login_user', 'method': 'facebook'});
});
// for Google Analytics END

function signInRequest(email, pass) {
  const urlSignin = document.querySelector("#auth").getAttribute("data-login");
  const paramsSignin =
    "SignInForm[email]=" +
    email +
    "&SignInForm[password]=" +
    pass +
    "&_csrf=" +
    jst_csrf;
  popupRequest(urlSignin, paramsSignin, "msg_error_signin");
}
// END SIGN IN

// FORGOT PASSWORD
let signInTitle = document.querySelector("#popup_title_signin").innerText;
let forgotPassTitle = document.querySelector("#popup_title_forgot_pass").innerText;

document.querySelector("#forgot_pass") &&
  document.querySelector("#forgot_pass").addEventListener("click", function () {
    togglePopupBlocks(forgotPassTitle);
  });
document.querySelector("#sign_in") &&
  document.querySelector("#sign_in").addEventListener("click", function () {
    togglePopupBlocks(signInTitle);
  });

function togglePopupBlocks(titlePopup) {
  document.getElementById("signin_email").value = "";
  document.getElementById("signin_password").value = "";
  document.querySelector(".block_bottom_sigin").classList.toggle("hide");
  document.querySelector("#popup_form_divider").classList.toggle("hide");
  document.querySelector("#block_signin_pass").classList.toggle("hide");
  document.querySelector("#block_bottom_forgot_pass").classList.toggle("show");
  document.querySelector(".popup__title").innerText = titlePopup;
}

document.getElementById("send_forgot_pass") &&
  document
    .getElementById("send_forgot_pass")
    .addEventListener("click", function () {
      let inputEmail = document.getElementById("signin_email");
      let inputEmailMsg = document.getElementById("signin_email_error");

      if (!validateEmail(inputEmail)) {
        inputEmailMsg.classList.add("show_msg");
        return;
      } else {
        inputEmailMsg.classList.remove("show_msg");
      }

      sendPassRequest(inputEmail.value);
    });
function sendPassRequest(email, pass) {
  const urlForgotPass = document
    .querySelector("#auth")
    .getAttribute("data-forgot-pass");
  const paramsForgot =
    "PasswordResetRequestForm[email] =" + email + "&_csrf=" + jst_csrf;
  popupRequest(urlForgotPass, paramsForgot, "msg_error_signin");
}
// END FORGOT PASSWORD
